/** 音乐组件 style.musicExt · 控件图标（缺省 = 现网 iconfont） */

export const MUSIC_EXT_SCHEMA_VERSION = 1;

export function ensureMusicExt(style) {
  if (!style || typeof style !== "object" || !style.musicExt) {
    return null;
  }
  return typeof style.musicExt === "object" ? style.musicExt : null;
}

/** 是否使用自定义图标；无 musicExt 或无 controlIconSrc 时为 false */
export function hasCustomMusicControlIcon(style) {
  const src = getMusicControlIconSrc(style);
  return !!(src && String(src).trim());
}

export function getMusicControlIconSrc(style) {
  if (!style || typeof style !== "object") {
    return "";
  }
  const ext = ensureMusicExt(style);
  if (ext && ext.controlIconSrc) {
    return String(ext.controlIconSrc).trim();
  }
  const info = ext && ext.controlIconInfo;
  if (info) {
    const p = info.file_down_path || info.fileDownPath || info.url;
    if (p) {
      return String(p).trim();
    }
  }
  return "";
}

export function initMusicExtOnStyle(style) {
  if (!style || typeof style !== "object") {
    return;
  }
  if (!style.musicExt || typeof style.musicExt !== "object") {
    style.musicExt = { schemaVersion: MUSIC_EXT_SCHEMA_VERSION };
  }
  if (style.musicExt.schemaVersion == null) {
    style.musicExt.schemaVersion = MUSIC_EXT_SCHEMA_VERSION;
  }
}

export function setMusicControlIcon(style, fileMeta) {
  if (!style || !fileMeta || !fileMeta.file_down_path) {
    return;
  }
  initMusicExtOnStyle(style);
  style.musicExt.controlIconSrc = fileMeta.file_down_path;
  style.musicExt.controlIconInfo = {
    file_down_path: fileMeta.file_down_path,
    file_real_name: fileMeta.file_real_name,
    file_md5: fileMeta.file_md5,
    id: fileMeta.id,
    file_name: fileMeta.file_name,
  };
}

export function clearMusicControlIcon(style) {
  if (!style || !style.musicExt) {
    return;
  }
  delete style.musicExt.controlIconSrc;
  delete style.musicExt.controlIconInfo;
  const rest = Object.keys(style.musicExt).filter((k) => k !== "schemaVersion");
  if (rest.length === 0) {
    delete style.musicExt;
  }
}

export function musicControlIconUploadPreview(style) {
  const src = getMusicControlIconSrc(style);
  if (!src) {
    return "";
  }
  if (src.indexOf("url(") === 0) {
    return src;
  }
  return `url(${src})`;
}
